<template lang="html">
  <div class="video">
      <div class="banner-img">
          <img width="100%" src="https://static.qyjmed.com/webSite/video/bg.png" alt="">
      </div>
      <!-- 视频 -->
      <div class="video-box">
          <div class="container">
              <!-- 最新视频 -->
              <div class="news-video">
                  <h2>最新视频<img src="https://static.qyjmed.com/webSite/video/zuixin.png"></h2>
                  <div class="news-box">
                      <div @click="newsVideo(index)" @mouseenter="onEnter(index)" @mouseleave="onLeave(index)"
                       class="news-box1" v-for="(items,index) in news.newList" :key="index">
                          <img :src="items.imgUrl" alt="">
                          <p>{{items.name}}</p>
                          <div  v-show="seen==index" class="shade">
                              <p><img src="https://static.qyjmed.com/webSite/video/play.png" alt="">观看视频</p>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- 热门视频 -->
              <div class="hot-video">
                  <h2>热门视频<img src="https://static.qyjmed.com/webSite/video/remen.png"></h2>
                  <div class="hot-box">
                      <ul>
                          <li @click="rankVideo(index)" v-for="(items,index) in news.rankList" :key="index">
                              <div class="hot-list">
                                  <p>{{index+1}}</p>
                                  <img :src="items.imgUrl" alt="">
                                  <div class="hot-content">
                                      <p>{{items.name}}</p>
                                      <p>观看{{items.count}}次</p>
                                  </div>
                              </div>
                          </li>

                      </ul>

                  </div>
              </div>
          </div>
      </div>
      <!-- 限时免费 -->
      <div class="limit">
          <div class="container">
              <h2>限时免费<img src="https://static.qyjmed.com/webSite/video/xianshimianfei.png"></h2>
              <div class="limit-box">
                  <div @click="freeVideo(index)" v-for="(items,index) in news.freeList" :key="index" class="limit-box1">
                      <img :src="items.imgUrl" alt="">
                      <p>{{items.name}}</p>
                  </div>
              </div>
          </div>
      </div>
      <div v-show='play' class="qyj-video-player">
          <div @click="shadow()" class="shadow">

          </div>
          <div class="video-show">
              <video-player class="video-player vjs-custom-skin"
    			ref="videoPlayer"
    			:playsinline="true"
    			:options="playerOptions"
    		></video-player>
          </div>
      </div>
      <Foot></Foot>
  </div>
</template>

<script>
import axios from 'axios'
import Foot from '@/components/Footer.vue'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'videos',
  data(){
      return{
          seen:'true',
          play: false,
          news:{
              freeList:{},
              newList:{},
              rankList:{}
          },
          playerOptions: {
				// playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				autoplay: false, //如果true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 导致视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [{
					type: "video/mp4",
					src: 'https://static.qyjmed.com/video/%E8%BF%88%E7%91%9E%E6%89%8B%E6%9C%AF%E5%BA%8A-_%E9%AB%98%E6%B8%85.mp4' //你的m3u8地址（必填）
				}],
				poster: "https://static.qyjmed.com/webSite/productService/document/video-bg.png", //你的封面地址
				width: document.documentElement.clientWidth,
				notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				//  controlBar: {
				//   timeDivider: true,
				//   durationDisplay: true,
				//   remainingTimeDisplay: false,
				//   fullscreenToggle: true //全屏按钮
				//  }
			},
            count:''
      }
  },
  created(){
      // this.getList()
  },
  methods:{
      onEnter:function(index){
          this.seen = index
      },
      onLeave:function(){
          this.seen = -1
      },
      // 最新视频播放
      newsVideo:function(index){
          this.play=true
          let a =this.news.newList[index].url
          this.playerOptions.sources[0].src=a

      },
      // 热门视频播放
      rankVideo:function(index){
          this.play=true
          this.playerOptions.sources[0].src=this.news.rankList[index].url
          axios.post('/api/oAuth/updateCount', {id : this.news.rankList[index].id }).then((res)=>{
              this.count = res.data
              console.log('提交成功')
          }).catch(function(err){
              console.log(err)
          })
      },
      // 免费视频播放
      freeVideo:function(index){
          this.play=true
          this.playerOptions.sources[0].src=this.news.freeList[index].url
      },
      shadow:function(){
          // this.playerOptions.sources[0].src=''
          this.$refs.videoPlayer.player.pause()
          this.play=false
      },
      getList:function(){
          axios.post('/api/oAuth/getSignUrl').then((res)=>{
              this.news = res.data.data
          }).catch(function(err){
              console.log(err)
          })
      },
  },
  mounted(){
    this.getList()
  },
  components: {
      Foot,
      videoPlayer
  }
}
</script>

<style lang="scss" scoped>
    .video{
        .banner-img{
            margin-top: $highlight-height;
            margin-bottom: -5px;
        }
        h2{
            margin:20px 0 18px;
            font-size: 26px;
            color: #3C3C3C;
            font-weight: 400;
            height: 38px;
            padding-left: 30px;
            img{
                margin-left: 30px;
            }
        }
        .video-box{
            background: #FAFAFA;
            padding-bottom: 40px;
            .container{
                // 最新视频
                .news-video{
                    width: 860px;
                    display: inline-block;
                    vertical-align: top;
                    .news-box{
                        padding:30px 30px 1px;
                        background: white;
                        .news-box1{
                            display: inline-block;
                            vertical-align: top;
                            height: 277px;
                            position: relative;
                            cursor: pointer;
                            >img{
                                width: 250px;
                            }
                            >p{
                                font-size: 18px;
                                color: #606060;
                                width: 200px;
                                margin-top: 18px;
                                line-height: 32px;
                            }
                            &:nth-child(3n+2){
                                padding:0 25px;
                            }
                            .shade{
                                width: 250px;
                                height: 140px;
                                background: #0A3C7B;
                                position: absolute;
                                top: 0;
                                opacity: 0.8;

                                p{
                                    text-align: center;
                                    height: 38px;
                                    color: white;
                                    font-size: 24px;
                                    margin-top: 22%;
                                    img{
                                        vertical-align: top;
                                        margin-right: 10px;
                                    }
                                }
                            }
                        }
                    }
                }
                // 热门视频
                .hot-video{
                    display: inline-block;
                    margin-left: 20px;
                    .hot-box{
                        padding:30px 15px 5px 15px;
                        background: white;
                        ul{
                            li{
                                margin-bottom: 30px;
                                div{
                                    cursor: pointer;
                                    &:hover{
                                        div{
                                            p{
                                                color: #1067b3;
                                            }
                                            p:last-child{
                                                color: #1067b3;
                                            }
                                        }
                                    }
                                    >p{
                                        display: inline-block;
                                        vertical-align: top;
                                    }
                                    img{
                                        display: inline-block;
                                        width: 108px;
                                        margin:0 18px;
                                    }
                                    div{
                                        display: inline-block;
                                        width: 136px;
                                        vertical-align: top;
                                        height: 80px;
                                        p{
                                            font-size: 14px;
                                            color: #000;
                                            &:first-child{
                                                height: 48px;
                                            }
                                            &:last-child{
                                                color: #606060;
                                                font-size: 12px;
                                                text-align: right;
                                                display: block;
                                                padding-right: 10px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .limit{
            background: #FAFAFA;
            padding-bottom: 50px;
            .container{
                background: white;
                h2{
                    margin: 0;
                    padding:20px 0 0 30px;
                }
                .limit-box{
                    padding: 30px;
                    .limit-box1{
                        display: inline-block;
                        margin-right: 30px;
                        vertical-align: top;
                        img{
                            max-width: 260px;
                        }
                        &:last-child{
                            margin-right: 0;
                        }
                        p{
                            height: 60px;
                            font-size: 18px;
                            color: #606060;
                            width: 240px;
                            line-height: 32px;
                            margin-top: 18px;
                        }
                    }
                }
            }
        }
        .qyj-video-player{
            .shadow{
                position: fixed;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 1;
                background: rgba(0,0,0,.5);
            }
            background: red;
            .video-show{
                position: fixed;
                margin:auto;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
                width: 1000px;
                height: 560px;
                z-index: 10000;
            }
        }
    }
</style>
